import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { SignUpLink } from '../SignUp';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';
import {Container} from "reactstrap";
import {reactLocalStorage} from 'reactjs-localstorage';
import Home from "../Home";
import Header from "../Header";
import axios from "axios";
import {BACKEND_BASE_URL} from "../../constants/routes";


class SignInPage extends Component {

    constructor(props) {
        super(props);
        this.state = {...this.INITIAL_STATE}
    }

    INITIAL_STATE = {
        email: '',
        password: '',
        error: null,
    };

    updateUser(user){
        this.props.updateNewUser(user)
    }
    onSubmit = event => {
        const { email, password } = this.state;
        axios.post(`${BACKEND_BASE_URL}/users/login`, {
            type : "workers",
            email: email,
            password:password
        }).then(
                res=> {
                    // console.log(res.data)
                    // reactLocalStorage.setObject('user', res.data);
                    // localStorage.setItem("user", res);
                    // console.log(super.props.firebase.users)
                    // this.props.firebase.users = res
                    // this.setState({ ...INITIAL_STATE })
                    this.props.history.push(ROUTES.HOME);
                    this.updateUser(res.data.data)
                    // this.props.firebase.userListener(res);
                    // console.log(this.props)

                }).catch(e=>{
                    console.log(e)
        })


        // this.props.firebase
        //     .doSignInWithEmailAndPassword(email, password)
        //     .then(() => {
        //         this.setState({ ...INITIAL_STATE });
        //         this.props.history.push(ROUTES.HOME);
        //     })
        //     .catch(error => {
        //         this.setState({ error });
        //     });
        event.preventDefault();
    };
    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    render() {
        const { email, password, error } = this.state;
        const isInvalid = password === '' || email === '';
        return (
            <div>
                <Container>
                    <form onSubmit={this.onSubmit}>
                        <input
                            name="email"
                            value={email}
                            onChange={this.onChange}
                            type="text"
                            placeholder="Email Address"
                        />
                        <input
                            name="password"
                            value={password}
                            onChange={this.onChange}
                            type="password"
                            placeholder="Password"
                        />
                        <button disabled={isInvalid} type="submit">
                            Sign In
                        </button>
                        {error && <p>{error.message}</p>}
                    </form>
                </Container>
            </div>

        );
    }
}

export default SignInPage;

